import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { UpdateUserLanguageDocument } from '@/__generated__/graphql';
import { toLanguageEnum } from '../language';
import type { AppLocale } from '../locale-storage';

/**
 * Guarda el idioma del usuario con `UpdateUserLanguage`, la misma mutation del legado. Devuelve la
 * región con `id` y `locale`, así Apollo actualiza `GetUserPreferences` en caché. Rechaza si falla.
 */
export function useUpdateUserLanguage(): (userId: number, locale: AppLocale) => Promise<void> {
  const [mutate] = useMutation(UpdateUserLanguageDocument);
  return useCallback(
    async (userId, locale) => {
      await mutate({ variables: { input: { userId, locale: toLanguageEnum(locale) } } });
    },
    [mutate],
  );
}
